
export const formatMoney = currencyCode => amount => amount.toLocaleString('en-US', { style: 'currency', currency: currencyCode })

